export const colors = {
  colors: ['#1EBFFD', '#FD338A', '#56FFC1', '#8E64F6', '#072530', '#FD8557']
};
